import React from 'react';

export function BasicsTab({ formData, setFormData, optimizing, optimizePrompt }) {
  return (
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">Name *</label>
        <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent" placeholder="z.B. Empfangs-Assistent" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">Beschreibung</label>
        <input type="text" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent" placeholder="Kurze Beschreibung des Agenten" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Begrüßung
          <span className="text-gray-400 font-normal ml-2">Erster Satz beim Anruf</span>
        </label>
        <textarea value={formData.inbound_greeting} onChange={(e) => setFormData({ ...formData, inbound_greeting: e.target.value })} rows={2} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm" placeholder='z.B. Herzlich Willkommen bei der Dion Hair Clinic, wie kann ich Ihnen helfen?' data-testid="inbound-greeting-textarea" />
        <p className="mt-1 text-xs text-gray-400">Wird automatisch aus dem Prompt erkannt wenn leer. Fallback: "Hallo, wie kann ich Ihnen helfen?"</p>
      </div>
      <div>
        <div className="flex flex-wrap items-center justify-between gap-1 mb-1.5">
          <label className="text-sm font-medium text-gray-700">
            System Prompt *
            <span className="text-gray-400 font-normal ml-1 sm:ml-2 hidden sm:inline">Persönlichkeit &amp; Verhalten</span>
          </label>
          <button type="button" onClick={optimizePrompt} disabled={optimizing || !formData.system_prompt?.trim()} className="text-xs px-3 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:from-purple-600 hover:to-pink-600 transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed shrink-0" title="Optimiert den Text im Feld mit KI" data-testid="optimize-prompt-btn">
            {optimizing ? (<>&#x23F3; Optimiere...</>) : (<>&#x2728; KI optimieren</>)}
          </button>
        </div>
        <textarea value={formData.system_prompt} onChange={(e) => setFormData({ ...formData, system_prompt: e.target.value })} rows={12} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent font-mono text-sm" placeholder="Du bist ein freundlicher Telefonassistent..." disabled={optimizing} data-testid="system-prompt-textarea" />
        <p className="mt-1.5 text-xs text-gray-400">Tipp: Definieren Sie hier auch die Begrüßung, z.B. &quot;Beginne jedes Gespräch mit: Guten Tag, hier ist...&quot;</p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Sprache</label>
          <select value={formData.language} onChange={(e) => setFormData({ ...formData, language: e.target.value })} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
            <option value="de">Deutsch</option>
            <option value="en">Englisch</option>
            <option value="es">Spanisch</option>
            <option value="fr">Französisch</option>
          </select>
        </div>
      </div>
    </div>
  );
}
